
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useAuth } from "@/lib/hooks/auth";

interface DashboardHeaderProps {
  onLogout: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onLogout }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // Function to get user initials for avatar
  const getUserInitials = (): string => {
    if (user?.firstName && user.firstName.length > 0) {
      return user.firstName.charAt(0).toUpperCase();
    }
    if (user?.email && user.email.length > 0) {
      return user.email.charAt(0).toUpperCase();
    }
    return "U"; // Default fallback
  };
  
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-10">
      <div className="flex items-center gap-4">
        <Avatar className="h-12 w-12 hidden md:flex">
          <AvatarFallback className="bg-primary/10 text-primary font-medium">
            {getUserInitials()}
          </AvatarFallback>
        </Avatar>
        <div>
          <span className="inline-block px-3 py-1 text-xs font-medium bg-clay-100 text-clay-800 rounded-full mb-4">
            {t("dashboard.myAccount")}
          </span>
          <h1 className="text-2xl md:text-3xl font-display font-bold mb-2">{t("dashboard.title")}</h1>
          <p className="text-muted-foreground">
            {t("dashboard.subtitle")}
          </p>
        </div>
      </div>
      <div className="mt-4 md:mt-0 flex gap-4">
        <Button 
          variant="outline" 
          className="w-full md:w-auto"
          onClick={() => navigate("/classes")}
        >
          {t("dashboard.bookNew")}
        </Button>
        <Button 
          variant="ghost" 
          className="w-full md:w-auto"
          onClick={onLogout}
        >
          {t("nav.logout")}
        </Button>
      </div>
    </div>
  );
};
